import { CostCodeCostTypeProjectCombinationBase } from './base/cost-code-cost-type-project-combination-base';

export class CostCodeCostTypeProjectCombination extends CostCodeCostTypeProjectCombinationBase { }